import { render, staticRenderFns } from "./BillapReport.vue?vue&type=template&id=531738ec"
import script from "./BillapReport.vue?vue&type=script&lang=js"
export * from "./BillapReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports